<style scoped lang="less">
  .login-form{
    width:368px;
    margin:73px auto 0;
  }
  .logo-wrap{
    font-size: 48px;
    color: rgba(0,0,0,0.85);
    letter-spacing: 0;
    text-align:center;
    margin-top: 200px;
    img{
      width: 68px;
      vertical-align: middle;
      margin-right: 20px;
    }
  }
</style>
<template>
  <div>
    <h2 class="logo-wrap">
      <img src="../../images/logo.png">Fancy视觉处理系统
    </h2>
    <Form ref="formValidate" :model="form" :rules="ruleValidate" class="login-form">
         <FormItem prop="username">
            <Input v-model="form.username" placeholder="账户" icon="person"></Input>
        </FormItem>
         <FormItem prop="password">
            <Input v-model="form.password" placeholder="密码" 
              type="password" icon="locked" 
              @on-enter="handleSubmit"></Icon>></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit" long>登录</Button>
        </FormItem>
    </Form>
  </div>
</template>
<script>
  import {
    LOGIN,
  } from '@/utils/api';

  export default {
    data() {
      return {
        form:{},
        ruleValidate:{
          username: [
              { required: true, message: '账号不能为空', trigger: 'blur' }
          ],
          password: [
              { required: true, message: '密码不能为空', trigger: 'blur' }
          ],
        }
      }
    },
    methods: {
      handleSubmit(){
        this.$refs.formValidate.validate((valid) => {
            if (valid) {
                if(this.form.username === 'admin' && this.form.password === 'admin'){
                  document.cookie="fvs=hello;path=/";
                  this.$router.push({
                    path:'/'
                  })
                }else{
                  this.$Message.error('用户名或密码错误');
                }
            } else {
                this.$Message.error('Fail!');
            }
        })
      }
    },
  };
</script>
